export const UPDATE_PASSWORD_SUCCESS = "password/UPDATE_SUCCESS";
export const UPDATE_PASSWORD_FAILURE = "password/UPDATE_FAILURE";

export const updatePasswordSuccess = () => ({ type: UPDATE_PASSWORD_SUCCESS });
export const updatePasswordFailure = error => ({
  type: UPDATE_PASSWORD_FAILURE,
  payload: error
});

const initialState = {
  error: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action?.type) {
    case UPDATE_PASSWORD_SUCCESS:
      return { ...state, error: null };
    case UPDATE_PASSWORD_FAILURE:
      return { ...state, error: action.payload };
    default:
      return state;
  }
}

export const getError = state => state.password.update.error;
